import {
	Component,
	OnInit,
	ElementRef,
	Input,
	OnChanges,
	SimpleChanges,
} from '@angular/core';
import { ChartDataSets } from 'chart.js';
import { Color } from 'ng2-charts';

@Component({
	selector: 'app-line-chart',
	templateUrl: './line-chart.component.html',
	styleUrls: ['./line-chart.component.scss'],
})
export class LineChartComponent implements OnInit, OnChanges {
	@Input() monthData: any;

	parentWidth = 0;
	parentHeight = 0;
	public lineChartLabels = [
		'Jan',
		'Fev',
		'Mar',
		'Abr',
		'Mai',
		'Jun',
		'Jul',
		'Ago',
		'Set',
		'Out',
		'Nov',
		'Dez',
	];

	public lineChartData: ChartDataSets[] = [];
	public lineChartColors: Color[] = [];
	public lineChartType = 'line';

	perMonthList = [];

	public lineChartOptions = {
		responsive: true,
		maintainAspectRatio: false,
		plugins: {
			legend: {
				display: false,
			},
		},
		scales: {
			x: {
				grid: {
					display: false,
				},
				ticks: {
					padding: 10,
				},
			},
			y: {
				grid: {
					drawBorder: false,
					drawTicks: false,
				},
			},
		},
		elements: {
			point: {
				radius: 0,
			},
			line: {
				tension: 0,
			},
		},
	};

	public options = {
		responsive: true,
		maintainAspectRatio: false,
		legend: {
			display: false,
			onClick: null,
		},
		layout: {
			padding: 20,
		},
		scales: {
			xAxes: [
				{
					id: 'x',
					ticks: {
						padding: 16,
					},
					gridLines: {
						color: 'rgba(229,222,255)',
						borderDash: [10, 5],
						borderDashOffset: 10,
						drawBorder: false,
						drawTicks: false,
						zeroLineColor: 'rgba(229,222,255)',
						zeroLineBorderDash: [10, 5],
						zeroLineBorderDashOffset: 10,
						tickMarkLength: 50,
					},
				},
			],
			yAxes: [
				{
					id: 'y',
					ticks: {
						fontColor: '#938F94',
						padding: 16,
					},
					gridLines: {
						color: 'rgba(229,222,255)',
						borderDash: [10, 5],
						borderDashOffset: 10,
						drawBorder: false,
						drawTicks: false,
						zeroLineColor: 'rgba(229,222,255)',
						zeroLineBorderDash: [10, 5],
						zeroLineBorderDashOffset: 10,
						tickMarkLength: 50,
					},
				},
			],
		},
		elements: {
			point: {
				radius: 5,
				hoverRadius: 6,
			},
			line: {
				tension: 0,
				borderDash: [0, 0],
			},
		},
	};

	allComplaints = {};
	loading = true;

	constructor(private el: ElementRef) {}

	ngOnInit(): void {
		const parent = this.el.nativeElement.parentElement;
		const parentWidth = parent.clientWidth;

		this.parentWidth = parentWidth;
		this.parentHeight = parentWidth / 1.5;

		this.allComplaints = this.monthData;

		this.loading = false;

		if (this.allComplaints) {
			this.getComplaints();
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.allComplaints = this.monthData;
		if (this.allComplaints) {
			this.lineChartData = [];
			this.getComplaints();
		}
	}

	private getMonthFromString(mon) {
		return this.lineChartLabels.indexOf(mon) + 1;
	}

	private getComplaints(): void {
		this.loading = true;

		const listByYear = [];
		const listByMonth = [];

		if (Object.keys(this.allComplaints).length > 0) {
			for (const key in this.allComplaints) {
				if (this.allComplaints.hasOwnProperty(key)) {
					const element = this.allComplaints[key];
					listByYear.push(element);
				}
			}

			let years = [];
			listByYear.map((item, index) => {
				let obj = {};

				for (const month in this.lineChartLabels) {
					obj[Number(month) + 1] = 0;
				}

				for (const key in item) {
					const month = this.getMonthFromString(key);
					obj[month] = item[key];
				}

				const listByMonthValues = Object.values(obj);

				years.push(Object.keys(this.allComplaints)[index]);
				listByMonth.push(listByMonthValues);
			});

			this.perMonthList = listByMonth.reduce((acc, cur, i) => {
				acc[years[i]] = cur;
				return acc;
			}, {});
		}

		this.createChartData();
		this.loading = false;
	}

	yearsLabels = [];
	colors = [
		'#2C009E',
		'#5B43D9',
		'#8F7FFF',
		'#C7BFFF',
		'#4223C1',
		'#745FF4',
		'#AB9FFF',
	];

	private createChartData(): void {
		const years = Object.keys(this.allComplaints);
		this.lineChartColors = [];
		this.lineChartData = [];
		this.yearsLabels = [];

		let count = 0;
		for (const year of years) {
			count++;

			const color =
				this.colors[(this.colors.length - count) % this.colors.length];
			this.yearsLabels.push({ year, color });

			this.lineChartColors.push({
				borderColor: color,
				backgroundColor: 'rgba(0,0,0,0)',
			});

			this.lineChartData.push({
				data: this.perMonthList[year],
				label: year,
				fill: false,
				borderWidth: 2,
				pointRadius: 2,
				borderColor: color,
				pointBackgroundColor: color,
			});
		}
	}
}
